var map = {
	"./program_co.lab.png": 378,
	"./program_creative.png": 379,
	"./program_demola.png": 380,
	"./program_doktors.png": 381,
	"./program_idealab.png": 382,
	"./program_product_project.png": 383,
	"./program_university.png": 384,
	"./program_vertikal.png": 385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;